import React from "react";
import style from "./item.module.css";

const Item = ({ item, addToCart }) => {

    const [itemAmount, setItemAmount] = React.useState("");

    const handleAddItem = () => {

        if (parseInt(itemAmount) > 0) {
            item.amount = itemAmount;
            addToCart(item);
            setItemAmount("")
        };
    };

    return (
        <div className={style.rootDiv}>
            <div className={style.content}>
                <div className={style.imgBox}>
                    <img src={`/items/${item.id}.png`} alt={item.id} loading="lazy"/>
                </div>
                <p className={style.title}>{item.item}</p>
                <div className={style.addToCart}>
                    <input placeholder="Amount" value={itemAmount} onChange={event => setItemAmount(event.target.value)}/>
                    <button disabled={parseInt(itemAmount) < 1} className={`${parseInt(itemAmount) >= 1 ? "" : style.disabledBtn}`} onClick={handleAddItem}>Add</button>
                </div>
            </div>
        </div>
    )
};

export default Item;